/* src/app/user-default/ticket/edit-ticket/edit-ticket.component.scss */
.paperclip {
  width: 24px;
  height: 24px;
}
.paperclip img {
  width: 100%;
  height: auto;
}
.upload-error {
  display: block;
  margin: 8px 0;
  font-family: leicht, sans-serif;
  font-size: 14px;
  line-height: 1.4;
  color: #c00;
  overflow-wrap: anywhere;
}
.upload-error span {
  display: block;
}
/*# sourceMappingURL=edit-ticket.component-KUE6S5Q5.css.map */
